// Basic
import PropTypes from 'prop-types';
// Components
import SubscriptionsStatusChart from '../charts/terminals/SubscriptionsStatusChart';
import NetworksChart from '../charts/terminals/NetworksChart';
import ContractsApplicationsChart from '../charts/contracts/ContractsApplicationsChart';
import ContractsCbVersionsChart from '../charts/contracts/ContractsCbVersionsChart';
import ManufacturersChart from '../charts/terminals/ManufacturersChart';
import SimOffersChart from '../charts/simCards/SimOffersChart';

/**
 * @param root0
 * @param root0.dashboardData
 * @returns {JSX} ChartsSection
 */
function ChartsSection({ dashboardData }) {
    return (
        <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 my-4'>
            <SubscriptionsStatusChart dashboardData={dashboardData} />
            <NetworksChart dashboardData={dashboardData} />
            <ManufacturersChart dashboardData={dashboardData} />
            <SimOffersChart dashboardData={dashboardData} />
            <ContractsApplicationsChart dashboardData={dashboardData} />
            <ContractsCbVersionsChart dashboardData={dashboardData} />
        </div>
    );
}

ChartsSection.propTypes = {
    dashboardData: PropTypes.object.isRequired
};

export default ChartsSection;